import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { UiFormModule } from '../../../shared/ui/ui-form.module';
import { SharedModule } from '../../shared/shared.module';
import { InvestmentAssetDetailComponent } from './components/investment-asset-detail/investment-asset-detail.component';
import { InvestmentAssetFormDialogComponent } from './components/investment-asset-form-dialog/investment-asset-form-dialog.component';
import { InvestmentAssetListComponent } from './components/investment-asset-list/investment-asset-list.component';

@NgModule({
  declarations: [
    InvestmentAssetListComponent,
    InvestmentAssetDetailComponent,
    InvestmentAssetFormDialogComponent,
  ],
  exports: [
    InvestmentAssetListComponent,
    InvestmentAssetDetailComponent,
    InvestmentAssetFormDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UiFormModule,
    SharedModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
  ],
})
export class InvestmentAssetSharedModule { }
